






import { Vue, Component } from 'vue-property-decorator';
import appConfig from '../../appConfig';

@Component
export default class OpenSourceLicense extends Vue {
    get openSourceLicenseUrl(): string {
        return appConfig.licensePageUrl;
    }
}
